export const integrationDetailsMessages = {
  testIntegrationSuccess: 'Integration was tested successfully.',
  testIntegrationStarting: 'The integration will be tested. The process may take a few minutes.',
  updateIntegrationSuccess: 'Integration was updated successfully.',
  unknownIntegrationError: 'Something went wrong.',
};
